import { Action } from "redux"
import { IGrid, NavigationWorkspaceChild } from "../../models"

export const INITIALIZE = "COVERPAGE_INITIALIZE"

export interface Initialize extends Action {
    workspaceId: number
    workspaceScreenLabel: string
    noWorkspaceContentFoundLabel: string
    noWorkspaceContentFoundFilteredLabel: string
    contentLabel: string
}

export const initialize = (
    workspaceId: number,
    workspaceScreenLabel: string,
    noWorkspaceContentFoundLabel: string,
    noWorkspaceContentFoundFilteredLabel: string,
    contentLabel: string,
): Initialize => ({
    type: INITIALIZE,
    workspaceId,
    workspaceScreenLabel,
    noWorkspaceContentFoundLabel,
    noWorkspaceContentFoundFilteredLabel,
    contentLabel,
})

export const REQUEST_WORKSPACE_CONTENT = "COVERPAGE_REQUEST_CONTENT"
export const RECEIVE_WORKSPACE_CONTENT = "COVERPAGE_RECEIVE_CONTENT"

export interface RequestWorkspaceContent extends Action {
    filter: string
    offset: number
    limit: number
}

export interface ReceiveWorkspaceContent extends Action {
    children: NavigationWorkspaceChild[]
    hasMore: boolean
}

export const requestWorkspaceContent = (
    filter: string,
    offset: number,
    limit: number,
): RequestWorkspaceContent => ({
    type: REQUEST_WORKSPACE_CONTENT,
    filter,
    offset,
    limit,
})

export const receiveWorkspaceContent = (
    children: NavigationWorkspaceChild[],
    hasMore: boolean,
): ReceiveWorkspaceContent => ({
    type: RECEIVE_WORKSPACE_CONTENT,
    children,
    hasMore,
})

export const REQUEST_COVERPAGE_GRID = "COVERPAGE_REQUEST_GRID"
export const RECEIVE_COVERPAGE_GRID = "COVERPAGE_RECEIVE_GRID"

export interface ReceiveCoverPageGrid extends Action {
    grid: IGrid
}

export const requestCoverPageGrid = (): Action => ({
    type: REQUEST_COVERPAGE_GRID,
})

export const receiveCoverPageGrid = (grid: IGrid): ReceiveCoverPageGrid => ({
    type: RECEIVE_COVERPAGE_GRID,
    grid,
})

export const UPDATE_TILES_ORDER = "COVERPAGE_GRID_UPDATE_TILES_ORDER"

export interface UpdateTilesOrder extends Action {
    targetIndex: number
    oldIndex: number
    reorderedTileId: number
    targetTileId: number
}

export const updateTilesOrder = (
    targetIndex: number,
    oldIndex: number,
    reorderedTileId: number,
    targetTileId: number,
): UpdateTilesOrder => ({
    type: UPDATE_TILES_ORDER,
    targetIndex,
    oldIndex,
    reorderedTileId,
    targetTileId,
})

export const REMOVE_TILE = "COVERPAGE_REMOVE_TILE"

export interface RemoveTile extends Action {
    tileId: number
}

export const removeTile = (tileId: number): RemoveTile => ({
    type: REMOVE_TILE,
    tileId,
})

export const mapDispatchToProps = {
    initialize,
    receiveWorkspaceContent,
    requestWorkspaceContent,
    receiveCoverPageGrid,
    requestCoverPageGrid,
    removeTile,
    updateTilesOrder,
}

export type DispatchProps = typeof mapDispatchToProps
